import { Concept } from 'modules/Documents/models/document';
import {
  formatNonTaxableTaxKey,
  formatTaxKey,
  getTaxType,
} from 'modules/Taxes/helpers';
import { NonTaxableTaxType, TaxType } from 'modules/Taxes/types';

export const processConceptTax = (concept: Concept) => {
  const affectedTaxes = [
    formatTaxKey(TaxType.IGIC, 0),
    formatTaxKey(TaxType.IPSI, 0),
    formatTaxKey(TaxType.IVA, 0),
  ];

  if (affectedTaxes.includes(concept.taxKey)) {
    const taxType = getTaxType(concept.taxKey);
    if (concept.taxExemption?.taxExemptionGroup === 'EXEMPTION') {
      return formatNonTaxableTaxKey(taxType, NonTaxableTaxType.Exempt, 0);
    }

    if (concept.taxExemption?.taxExemptionGroup === 'NOT_SUBJECT') {
      return formatNonTaxableTaxKey(taxType, NonTaxableTaxType.NotSubject, 0);
    }

    if (concept.taxExemption?.taxExemptionGroup === 'SUBJECT_INVERSION') {
      return formatNonTaxableTaxKey(
        taxType,
        NonTaxableTaxType.ReverseCharge,
        0
      );
    }
  }

  return concept.taxKey;
};
